module.exports = __webpack_public_path__ + "static/img/ldy.9502d561.jpg";